<template>
  <div class="absolute inset-0 p-2 pb-24 pointer-events-none">
    <div
      class="w-full bg-black bg-opacity-50 text-left overflow-auto p-2 select-text text-xs pointer-events-auto max-h-full"
    >
      <div class="sticky top-0 border-b mb-2">
        <div class="flex justify-between">
          <div class="flex gap-2 text-gray-400">
            <button
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              :class="{ 'border-white text-white': activeTab === 'errors' }"
              @click="setActiveTab('errors')"
            >
              Errors
              <span
                v-if="errors.length"
                class="ml-1 py-0.5 px-1 rounded-full bg-red-600"
              >
                {{ errors.length }}
              </span>
            </button>
            <button
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              :class="{
                'border-white text-white': activeTab === 'currentEntry',
              }"
              @click="setActiveTab('currentEntry')"
            >
              Current entry
            </button>
            <button
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              :class="{ 'border-white text-white': activeTab === 'allEntries' }"
              @click="setActiveTab('allEntries')"
            >
              All entries
              <span class="ml-1 py-0.5 px-1 rounded-full bg-gray-700">
                {{ entries.length }}
              </span>
            </button>
            <button
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              :class="{
                'border-white text-white': activeTab === 'latestAnswer',
              }"
              @click="setActiveTab('latestAnswer')"
            >
              Latest answer
            </button>
            <button
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              :class="{ 'border-white text-white': activeTab === 'allAnswers' }"
              @click="setActiveTab('allAnswers')"
            >
              All answers
              <span
                v-if="answers.length"
                class="ml-1 py-0.5 px-1 rounded-full bg-gray-700"
              >
                {{ answers.length }}
              </span>
            </button>
          </div>
          <div>
            <button
              v-if="answers.length"
              class="px-2 py-1 border-b-4 -mb-px border-transparent"
              @click="finish"
            >
              Finish
            </button>
          </div>
        </div>
      </div>
      <div v-show="activeTab === 'errors'">
        <div v-if="errors.length" class="space-y-2">
          <div v-for="(error, index) in errors" :key="index">
            <div class="text-red-500">ERROR! {{ error.message }}</div>
            <pre class="whitespace-pre-wrap">{{ error.entry }}</pre>
          </div>
        </div>
        <div v-else>✔ No errors</div>
      </div>
      <div v-show="activeTab === 'currentEntry'">
        <pre class="whitespace-pre-wrap">{{ entries[currentEntryIndex] }}</pre>
      </div>
      <div v-show="activeTab === 'allEntries'">
        <pre class="whitespace-pre-wrap">{{ entries }}</pre>
      </div>
      <div v-show="activeTab === 'latestAnswer'">
        <pre class="whitespace-pre-wrap">{{ answers[answers.length - 1] }}</pre>
      </div>
      <div v-show="activeTab === 'allAnswers'">
        <pre class="whitespace-pre-wrap">{{ answers }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Log',
  data() {
    return {
      activeTab: 'errors',
    }
  },
  computed: {
    ...mapState(['currentEntryIndex', 'entries', 'errors', 'answers']),
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab
    },
    finish() {
      const finalIndex = this.entries.length
      this.$store.state.currentEntryIndex = finalIndex
      localStorage.setItem('currentEntryIndex', finalIndex)
    },
  },
  mounted() {
    if (this.errors.length > 0) {
      this.activeTab = 'errors'
    } else if (this.answers.length > 0) {
      this.activeTab = 'latestAnswer'
    } else {
      this.activeTab = 'currentEntry'
    }
  },
}
</script>
